import log from 'salvo-lite/log'
import axios from 'axios'
import Queue from '../helpers/Queue.js'

class AjaxCart {
    constructor (theme, elem) {
        this.theme = theme
        this._elem = elem
        this.options = Object.assign({
            dontInit: false,
            refresh: '/cart'
        }, JSON.parse(this._elem.dataset.options || '{}'))
        this._queue = new Queue()
        this._events = this.createEvents()
        if (this._elem.nodeName === 'FORM') {
            this._button = this._elem.querySelector('button[type="submit"]')
        } else {
            this._button = this._elem
        }
        if (!this.options.dontInit) {
            this.init()
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    init () {
        log.debug(this.constructor.name, 'Initiating')

        if (this._elem.nodeName === 'FORM') {
            this._elem.addEventListener('submit', (e) => {
                e.preventDefault()
                this.addToCart()
            })
        } else {
            this._elem.addEventListener('click', (e) => {
                e.preventDefault()
                this.addToCart()
            })
        }
        this._elem.setAttribute('ajax-cart-initiated', true)
        log.debug(this.constructor.name, 'Initiated')
    }

    onInit () {
    }

    addToCart () {
        this._queue.enqueue(() => {
            this._button.setAttribute('disabled', 'disabled')
            let variantId = this._elem.dataset.variantId || this._elem.querySelector("[name='id']").value
            let quantity = parseInt(this._elem.dataset.quantity) || this._elem.querySelector("[name='quantity']").value
            let properties = {}

            let propElems = this._elem.querySelectorAll('input[name^="properties"]')

            for (let propElem of propElems) {
                // Just accept it
                let name = propElem.getAttribute('name').split('[')[1].split(']')[0]
                properties[name] = propElem.value
            }

            return axios.post('/cart/add.js', {
                id: variantId,
                quantity: quantity,
                properties: properties
            }).then(() => {
                log.debug(this.constructor.name, 'Added item')
                this._button.removeAttribute('disabled')
                document.dispatchEvent(this._events.addedItem)
                localStorage.setItem('go_to_cart', 'yes')
                window.location = this.options.refresh
            })
        })
    }

    createEvents () {
        return {
            addedItem: new Event('added-item')
        }
    }
}

export default AjaxCart



// WEBPACK FOOTER //
// ./src/scripts/components/AjaxCart.js